import '@mantine/core/styles.css';

import ReactDOM from 'react-dom/client';
import { Center, MantineProvider } from '@mantine/core';
import { CowIcon } from '@phosphor-icons/react';
import theme from './theme';

const rootEl = document.getElementById('root');
const root = ReactDOM.createRoot(rootEl);

root.render(
  <MantineProvider
    theme={theme}
    forceColorScheme="dark"
  >
    <Center h="100vh">
      <CowIcon
        size={120}
        color="var(--mantine-primary-color-filled)"
      />
    </Center>
  </MantineProvider>,
);
